import { MarketplaceType } from '@config/types'
import CONTRACTS_CONFIG from './contracts.config'

const BASIS_POINT = 200

const MARKETPLACE_CONFIG: MarketplaceType = {
  apiToken: '1ce2e38a-a4df-5155-a491-59f9f18b536c',
  contract: CONTRACTS_CONFIG.mainnet.marketplace,
  chainId: 324,
  chainName: 'zkSync',
  baseApiUrl: 'https://api-zksync.reservoir.tools',
  marketplaceFees: [`${CONTRACTS_CONFIG.mainnet.marketplaceFees}:${BASIS_POINT}`]
}

MARKETPLACE_CONFIG.enabled = true
export default MARKETPLACE_CONFIG
